import { create } from "zustand";
import type {
  PayoutMethodType,
  PayoutInput,
  RecipientInput,
} from "../interfaces/payout";
import type { FundingMethod } from "../utils/sendCatalog";
import type { IQuoteResponse } from "../services/api";

export interface ISendDraft {
  sourceCountry: string;
  destinationCountry: string;
  sourceCurrency: string;
  destinationCurrency: string;
  amount: number;
  fundingMethod: FundingMethod;
  payoutMethod: PayoutMethodType;
  payout: PayoutInput;
  recipient: RecipientInput;
  capabilityKey?: string;
  fundingPaymentMethodId?: string;
}

interface SendState {
  draft: ISendDraft | null;
  setDraft: (draft: ISendDraft | null) => void;
  quoteState: IQuoteResponse | null;
  setQuoteState: (quoteState: IQuoteResponse | null) => void;
  reset: () => void;
}

export const useSendStore = create<SendState>((set) => ({
  draft: null,
  setDraft: (draft) => set(() => ({ draft })),
  quoteState: null,
  setQuoteState: (quoteState) => set(() => ({ quoteState })),
  reset: () => set(() => ({ draft: null, quoteState: null })),
}));
